/**
 * @module funcao/funcao
 */

import { Plugin } from 'ckeditor5/src/core';
import FuncaoEditing from './funcaoediting';
import FuncaoUI from './funcaoui';

/**
 * The estrutura plugin.
 *
 * It loads the {@link module:funcao/funcaoediting~FuncaoEditing FuncaoEditing feature}
 *
 * @extends {Plugin}
 */
export default class Funcao extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Funcao';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ FuncaoEditing, FuncaoUI ];
	}
}
